/**
 * Hero slideshow: vertical scroll must not change slides.
 * Only a clearly horizontal swipe may move the carousel.
 */
(() => {
  const THRESHOLD = 10;
  // Horizontal must win clearly; ambiguous / vertical → page scroll only
  const HORIZONTAL_RATIO = 1.6;

  let startX = 0;
  let startY = 0;
  let axis = null; // 'x' | 'y' | null
  let active = false;

  const inSlideshow = (target) =>
    target instanceof Element && Boolean(target.closest('.slideshow'));

  const onStart = (event) => {
    if (!event.touches?.[0] || !inSlideshow(event.target)) {
      active = false;
      return;
    }
    const touch = event.touches[0];
    startX = touch.clientX;
    startY = touch.clientY;
    axis = null;
    active = true;
  };

  const onMove = (event) => {
    if (!active || !event.touches?.[0] || !inSlideshow(event.target)) return;

    const touch = event.touches[0];
    const dx = Math.abs(touch.clientX - startX);
    const dy = Math.abs(touch.clientY - startY);

    if (!axis) {
      if (dx < THRESHOLD && dy < THRESHOLD) {
        // Hold Flickity until we know the intent
        event.stopImmediatePropagation();
        return;
      }
      axis = dx > dy * HORIZONTAL_RATIO ? 'x' : 'y';
    }

    if (axis === 'y') {
      // Vertical scroll: block Flickity so slides don't move sideways
      event.stopImmediatePropagation();
    }
  };

  const onEnd = () => {
    active = false;
    axis = null;
  };

  document.addEventListener('touchstart', onStart, { passive: true, capture: true });
  document.addEventListener('touchmove', onMove, { passive: true, capture: true });
  document.addEventListener('touchend', onEnd, { passive: true, capture: true });
  document.addEventListener('touchcancel', onEnd, { passive: true, capture: true });
})();
